import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { App } from '@capacitor/app';
import { Preferences } from '@capacitor/preferences';
import { Capacitor } from '@capacitor/core';
import { environment } from 'src/environments/environment';

export interface ReleaseNoteItem {
  type: 'heading' | 'paragraph' | 'bullet';
  text: string;
}

// The app version these notes describe. The modal only shows when the running
// app version matches - a release without updated notes shows nothing.
//
// Set to the current app version. home.page.ts compares this to the running
// version with an exact string match, so a mismatch is silent: no modal, and
// nothing to say why. If the release that carries these notes cuts a different
// version, this has to move with it.
export const RELEASE_NOTES_VERSION = '3.6.3';

// Covers everything since the 3.6.0 notes - 133 commits, five resident-visible
// themes. ONE SENTENCE EACH, in plain language: this is read once, by someone
// who wants to know what is different, not how it works. Anything a resident
// cannot see (scene sync, the 2N and iOS build fixes, the mood-audio internals)
// is deliberately absent.
export const RELEASE_NOTES_CONTENT: ReleaseNoteItem[] = [
  { type: 'heading', text: 'Messages, Simplified' },
  { type: 'paragraph', text: 'Home shows only what you have not read yet, and your full history is under Notifications.' },

  { type: 'heading', text: 'Lights Show Their Real Brightness' },
  { type: 'paragraph', text: 'The dimmer shows how bright a light actually is, and says Off when it is off.' },

  { type: 'heading', text: 'Mood Audio Volume' },
  { type: 'paragraph', text: 'You can now set how loud mood audio plays.' },

  { type: 'heading', text: 'Vessel Intelligence' },
  { type: 'paragraph', text: 'Suggested questions to get you started, plus Back and Clear chat.' },

  { type: 'heading', text: 'Polish & Reliability' },
  { type: 'paragraph', text: 'Steadier control of your home when your connection drops.' }
];

@Component({
  selector: 'release-notes-modal',
  templateUrl: './release-notes-modal.component.html',
  styleUrls: ['./release-notes-modal.component.scss']
})
export class ReleaseNotesModalComponent implements OnInit {
  @Output() onClose = new EventEmitter<void>();
  currentVersion: string = '';
  releaseNotes: ReleaseNoteItem[] = RELEASE_NOTES_CONTENT;

  constructor() {}

  async ngOnInit() {
    try {
      if (Capacitor.isNativePlatform()) {
        const info = await App.getInfo();
        this.currentVersion = info.version;
      } else {
        // On web, use the version from environment
        this.currentVersion = environment.appVersion;
      }
    } catch (error) {
      console.error('Error getting app version:', error);
      this.currentVersion = environment.appVersion;
    }
  }

  async markAsSeen() {
    await Preferences.set({
      key: 'releaseNotesVersion',
      value: this.currentVersion
    });
    this.onClose.emit();
  }
} 